export default __webpack_public_path__ + "static/media/farmer.1732b957.svg";